import { useMutation } from "@tanstack/react-query";
import Swal from "sweetalert2";
import { api } from "../../libs/axios";
import { AxiosErrorResponse } from "../pdv/mutationReserva";
import { queryClient } from "../../libs/queryClient";
import { formUsuarioNovo } from "../../schemas/usuario";

export function useMutationNovoUsuario() {
  return useMutation({
     mutationFn: async (data: formUsuarioNovo) => {
      const response = await api.post(`/usuario`, data);

      return response.data;
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: ['usuarios-lista'],
        exact: false,
      })

      Swal.fire({
        title: 'Usuário Salvo',
        icon: 'success'
      });
    },
    onError: (err: AxiosErrorResponse) => {
      const requestId = err.response?.headers?.['request-id'];
      
      Swal.fire({
        title: "Erro ao salvar",
        icon: "error",
        text: `${err.response?.data?.data?.message || "Erro desconhecido"} ${requestId ? `- Request ID: ${requestId}` : ''}`,
      })
    }
  });
}
